export default __webpack_public_path__ + "static/centuryLogo-f52cb235b2bccba08257b056a8e10f7b.svg";